<div class=" min-h-screen">
  <app-shared-layout
  [Analysis]="title"
  [hideAdd]="false"
  [viewDetails]="viewDetails"
  [addPermission]="addPermission"
  [smallForm]="viewType !== 'view'"
  [secondaryWithStyle]="viewType !== 'view'"
  [animationSize]="viewType !== 'view' ? 'eighty' : 'full'"
  (addItem)="onAdd()"
  [formTitle]="viewDetailsTitle"
  (closeDetails)="closePanel()"
>
  <div ngProjectAs="primary-panel">
    <app-paginated-data-table
      [query]="query"
      [tableConfigurations]="tableConfiguration"
      [actionButtons]="actionButtons"
      [permissions]="permissions"
      (customAction)="customAction($event)"
      [upsertAction]="upsertAction"
      [deleteAction]="removeAction"
      [mapFunction]="mapFunction"
    >
    </app-paginated-data-table>
  </div>

  <div ngProjectAs="secondary-panel">
<!--    <app-faq-view-->
<!--      *ngIf="viewType === 'view'"-->
<!--      (onClose)="closePanel()"-->
<!--    >-->
<!--    </app-faq-view>-->
  </div>
</app-shared-layout>
</div>
